import React, { useEffect, useState } from 'react';
import { Avatar, Button, Divider } from "antd";

const Support = (props) => {
    // 使用 useState 处理状态
    const [myObject] = useState(props.myObject || { name: '没有传值的默认值' }); // props 传递的数据
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    /**
     * 模拟 componentDidMount
     * 在组件首次挂载时执行一次，可以用于数据请求、订阅等操作。
     */
    useEffect(() => {
        console.log('Component did mount');

        // 模拟数据请求
        const timer = setTimeout(() => {
            setData('Hello, React!');
            setLoading(false);
        }, 2000);

        // 返回一个清理函数，模拟 componentWillUnmount
        return () => {
            console.log('Component will unmount');
            clearTimeout(timer); // 清理定时器，避免内存泄漏
        };
    }, []); // 空依赖数组表示仅在挂载和卸载时运行

    /**
     * 模拟 componentDidUpdate
     * 监听特定状态（如 data）的变化。
     */
    useEffect(() => {
        if (data !== null) {
            console.log('Component did update with new data');
        }
    }, [data]); // 当依赖项 data 发生变化时运行

    /**
     * 模拟组件生命周期的多个状态监听
     * 如果需要同时监听多个状态或 prop 的变化，可以使用多个 useEffect。
     */
    useEffect(() => {
        console.log('Props or other states can also be tracked here.');
    }, [myObject]); // 当 myObject 发生变化时运行

    return (
        <div>
            <h1>Lifecycle Example</h1>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <p>Data fetched: {data}</p>
            )}
            <Button type="primary">函数式组件 {JSON.stringify(myObject)}</Button>
            <Divider />
            <Avatar />
        </div>
    );
};

export default Support;
